import { certificateData } from '../data/certificateData';

interface CertificateCardProps {
  recipientName: string;
  companionName: string;
}

export function CertificateCard({ recipientName, companionName }: CertificateCardProps) {
  return (
    <div className="min-h-screen flex items-center justify-center px-3 sm:px-4 py-8 sm:py-12 relative z-10">
      <div className="max-w-2xl w-full bg-warm-beige rounded-xl sm:rounded-2xl shadow-2xl p-6 sm:p-8 md:p-12 fade-in">
        {/* Заголовок: ДВА ПОДАРОЧНЫХ СЕРТИФИКАТА */}
        <div className="text-center mb-4 sm:mb-6">
          <h1 className="font-serif text-2xl sm:text-3xl md:text-4xl text-text-primary mb-2 sm:mb-3">
            ДВА ПОДАРОЧНЫХ СЕРТИФИКАТА
          </h1>
          <p className="text-base sm:text-lg text-text-secondary mb-2">
            для {recipientName} и {companionName}
          </p>
          <p className="text-sm sm:text-base text-text-secondary">
            Вдвоём будет веселее — можно пообщаться и расслабиться
          </p>
        </div>
        
        {/* Два часа финской сауны */}
        <div className="text-center mb-3 sm:mb-4 py-4 sm:py-6 border-t border-warm-gold/30">
          <h2 className="text-xl sm:text-2xl md:text-3xl text-text-primary font-serif mb-2 sm:mb-3">
            Два часа финской сауны
          </h2>
          {/* Запишитесь на удобную дату - сразу под заголовком */}
          {certificateData.features.map((feature, i) => (
            <p key={i} className="text-text-secondary text-sm sm:text-base flex items-center justify-center">
              <span className="mr-2 flex-shrink-0">✨</span>
              <span>{feature}</span>
            </p>
          ))}
        </div>
        
        {/* Разделитель */}
        <div className="border-t border-warm-gold/30 pt-4 sm:pt-6 space-y-2">
          {/* Название места */}
          {certificateData.placeName && (
            <p className="text-text-primary text-sm sm:text-base font-semibold text-center">
              {certificateData.placeName}
            </p>
          )}
          {certificateData.placeDescription && (
            <p className="text-text-secondary text-xs sm:text-sm text-center mb-2">
              {certificateData.placeDescription}
            </p>
          )}
          
          {/* Стоимость */}
          {certificateData.price && (
            <p className="text-text-secondary text-xs sm:text-sm text-center mb-3">
              каждый сертификат на {certificateData.price} ₽
            </p>
          )}
          
          {/* Контакты */}
          <div className="flex items-start justify-center text-xs sm:text-sm mb-2">
            <span className="mr-2 flex-shrink-0">📍</span>
            <a
              href={certificateData.address.mapUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-text-secondary hover:text-warm-gold transition-colors underline break-words"
            >
              {certificateData.address.full}
            </a>
          </div>
          <div className="flex items-center justify-center text-xs sm:text-sm">
            <span className="mr-2 flex-shrink-0">📞</span>
            <a
              href={`tel:${certificateData.phone.replace(/\s/g, '')}`}
              className="text-text-secondary hover:text-warm-gold transition-colors"
            >
              {certificateData.phone}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
